import React, { useEffect } from 'react';
import lodash from 'lodash';
import { connect } from 'react-redux';

import {
    getCustomEventType,
    unloadCustomEventType,
} from 'common/actions/eventTypes';
import {
    fetchApiIntegrations,
    cleanApiIntegrations,
} from 'common/actions/apiConfiguration';

import EditEventType from './EditEventType';
import styles from './styles.scss';

export function InstitutionalAdminEditEventType(props) {
    useEffect(() => {
        props.getCustomEventType(props.institutionId, props.eventTypeId);
        props.fetchApiIntegrations(props.institutionId);
        return () => {
            props.unloadCustomEventType();
            props.cleanApiIntegrations();
        };
    }, [props.institutionId]);

    return (
        <EditEventType
            className={styles.institutionalAdmin}
            goBackTo={'/admin/events'}
            {...props}
            data-cy="InstitutionalAdminEditEventType"
        />
    );
}

export default connect((state, props) => {
    const { 
        params: { eventTypeId }
    } = props;
    const institutionId = lodash.get(state, 'me.institution.id', null);
    const eventType = lodash.get(state, 'customEventType', {}) || {};
    const apiIntegrations = lodash.get(state, 'apiConfiguration.apiIntegrations', []) || [];
    const isLoading = lodash.isEmpty(eventType);
    return {
        institutionId,
        eventTypeId,
        eventType,
        isLoading,
        apiIntegrations,
    };
}, {
    getCustomEventType,
    unloadCustomEventType,
    fetchApiIntegrations,
    cleanApiIntegrations,
})(InstitutionalAdminEditEventType);
